"use strict";

var moduleName = "bonuses";

module.exports = function () {
	$(".jsBonuses").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Показываем блок генерации купона
		//

		$(".jsBtnGenerate").on("click", function(e) {
			e.preventDefault();

			$(this).hide();
			$(".jsCouponGeneration").show(200);
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/bonusesInit.js
 **/